<div class="page-content">
  <!-- Main Content Card -->
  <div class="row">
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card shadow-sm">
        <div class="card">
          <div class="card-header d-flex">
            <div class="row mb-2">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-md-6">
                    <h4>User Events</h4>
                  </div>
                  <div class="col-md-3">
                    <button type="button" [class]="userType==='CUSTOMER' ? 'contact selected':'contact'" (click)="getDataByUserType('CUSTOMER')">Customer</button>
                  </div>
                  <div class="col-md-3">
                    <button type="button" [class]="userType==='MERCHANT' ? 'contact selected':'contact'" (click)="getDataByUserType('MERCHANT')">Merchant</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <!-- Filter Accordion -->
            <ngb-accordion #acc="ngbAccordion" activeIds="filter-panel">
              <ngb-panel id="filter-panel" title="Filters">
                <ng-template ngbPanelContent>
                  <form [formGroup]="eventForm">
                    <!-- Filter Inputs -->
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <label class="form-label fw-medium">{{ userType === 'MERCHANT' ? 'Merchant ID' : 'User ID' }}</label>
                        <div class="input-group">
                          <input class="form-control" [(ngModel)]="userId" [ngModelOptions]="{standalone: true}" [placeholder]="userType === 'MERCHANT' ? 'Enter merchant ID' : 'Enter user ID'">
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <label class="form-label fw-medium">Mobile Number</label>
                        <div class="input-group">
                          <input type="text" class="form-control" [(ngModel)]="mobileNumber" [ngModelOptions]="{standalone: true}" placeholder="Enter Mobile Number">
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label class="form-label fw-medium">Event Action</label>
                        <ng-select 
                          [items]="eventActionOptions"
                          bindLabel="eventConstant"
                          bindValue="eventConstant"
                          placeholder="Select Event Action"
                          [clearable]="true"
                          [(ngModel)]="eventAction"
                          [ngModelOptions]="{standalone: true}">
                        </ng-select>
                      </div>
                    </div>

                    <!-- Date Range Filters -->
                    <div class="row mb-3">
                      <div class="col-md-4">
                        <label class="col-form-label" for="fromDateTime">From Date & Time</label>
                        <input id="startDateTime" type="datetime-local" class="form-control" formControlName="fromDate"
                          [(ngModel)]="startDateTime" (change)="onStartDateTimeChange()" name="startDateTime" required
                          [max]="currentDateTime" />
                        <div class="invalid-feedback" style="display: block;"
                          *ngIf="submitted && eventFormControls.fromDate.errors">
                          <div *ngIf="eventFormControls.fromDate.errors?.required">
                            From Date & Time is required
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label class="col-form-label" for="toDateTime">To Date & Time</label>
                        <input id="endDateTime" type="datetime-local" class="form-control" [(ngModel)]="endDateTime"
                          (change)="onEndDateTimeChange()" name="endDateTime" formControlName="toDate" [min]="startDateTime"
                          [max]="currentDateTime" />
                        <div class="invalid-feedback" style="display: block;"
                          *ngIf="submitted && eventFormControls.toDate.errors?.required">
                          To Date & Time is required
                        </div>
                      </div>

                      <div class="col-sm-4 d-flex align-items-end">
                        <button type="button" class="btn bg-danger-custom me-2" (click)="applyFilters()" style="width: 100%;">
                          <i class="feather icon-filter me-2"></i>Apply Filters
                        </button>
                        <button type="button" class="btn btn-secondary me-2" (click)="clearFilters()" style="width: 100%;">
                          <i class="feather icon-refresh-cw me-2"></i>Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>

            <!-- Data Grid -->
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive border rounded">
                  <ag-grid-angular 
                    style="width: 100%; height: 500px;" 
                    class="ag-theme-alpine" 
                    [rowData]="rowData"
                    [columnDefs]="columnDefs" 
                    [defaultColDef]="defaultColDef" 
                    [pagination]="false"
                    (gridReady)="onGridReady($event)">
                  </ag-grid-angular>
                </div>
              </div>
            </div>

            <!-- Add Pagination Controls -->
            <div class="row mt-3" *ngIf="totalElements > 0">
              <div class="col-md-6">
                <p class="text-muted">Showing {{ (pageNumber * pageSize) + 1 }} to {{ Math.min((pageNumber + 1) * pageSize, totalElements) }} of {{ totalElements }} entries</p>
              </div>
              <div class="col-md-6">
                <nav aria-label="Page navigation">
                  <ul class="pagination justify-content-end">
                    <li class="page-item" [class.disabled]="pageNumber === 0">
                      <a class="page-link" href="javascript:void(0)" (click)="onPageChange(0)">First</a>
                    </li>
                    <li class="page-item" [class.disabled]="pageNumber === 0">
                      <a class="page-link" href="javascript:void(0)" (click)="onPageChange(pageNumber - 1)">Previous</a>
                    </li>
                    
                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of [].constructor(totalPages > 5 ? 5 : totalPages); let i = index">
                      <li class="page-item" [class.active]="getPageNumberToShow(i) === pageNumber">
                        <a class="page-link" href="javascript:void(0)" (click)="onPageChange(getPageNumberToShow(i))">
                          {{ getPageNumberToShow(i) + 1 }}
                        </a>
                      </li>
                    </ng-container>
                    
                    <li class="page-item" [class.disabled]="pageNumber >= totalPages - 1">
                      <a class="page-link" href="javascript:void(0)" (click)="onPageChange(pageNumber + 1)">Next</a>
                    </li>
                    <li class="page-item" [class.disabled]="pageNumber >= totalPages - 1">
                      <a class="page-link" href="javascript:void(0)" (click)="onPageChange(totalPages - 1)">Last</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Event Details Modal -->
<app-modal #modalReportCustomer [modalConfig]="modalConfigReport">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <h5 class="text-primary mb-3">
          <i data-feather="info" class="icon-sm me-2"></i>Event Details
        </h5>
        <div *ngIf="tableInfo">
          <div class="row mb-3 bg-light p-3 rounded">
            <div class="col-md-6">
              <p class="mb-2"><strong class="text-dark">Mobile Number:</strong> {{ tableInfo.mobileNumber }}</p>
              <p class="mb-2" *ngIf="userType === 'MERCHANT' && tableInfo.merchantName"><strong class="text-dark">Merchant Name:</strong> {{ tableInfo.merchantName }}</p>
              <p class="mb-0"><strong class="text-dark">Event Action:</strong> {{ tableInfo.eventAction }}</p>
            </div>
          </div>
          
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead class="table-light">
                <tr>
                  <th>Event Type</th>
                  <th>Event Message</th>
                  <th>Status Code</th>
                  <th>Event Time</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let event of selectedEventDetails">
                  <td>{{ event.eventType }}</td>
                  <td>{{ event.eventMessage }}</td>
                  <td>
                    <span [ngClass]="{'badge bg-success': event.eventStatus === '200', 
                                      'badge bg-danger': event.eventStatus === '400' || event.eventStatus === '401',
                                      'badge bg-warning': event.eventStatus === '500'}">
                      {{ event.eventStatus }}
                    </span>
                  </td>
                  <td>{{ event.eventTime | date:'medium' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>

